import { Component, input } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
} from '@angular/forms';
import { FormErrorComponent } from '../error/form-error.component';
import { IsErrorColoredPipe } from '../error/form-error.pipe';

@Component({
  selector: 'shared-form-input-checkbox',
  templateUrl: './form-input-checkbox.component.html',
  styleUrls: ['./form-input-checkbox.component.css'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormErrorComponent,
    IsErrorColoredPipe,
  ],
})
export class FormInputCheckboxComponent {
  title = input<string>();

  tabIndex = input<number>();

  control = input.required<FormControl<unknown>>();

  validationErrors = input<ValidationErrors>();

  required = input<boolean>(false);

  testId = input<string | undefined>(undefined);
}
